import {Alert, Box, CircularProgress} from '@mui/material';
import MysteryTestHotel from './MysteryTestHotel';
import {useSelector} from 'react-redux';
import {Selector} from '../../state/selector';
import StartMysteryTestInfo from './StartMysteryTestInfo';
import MysteryTestHeader from './MysteryTestHeader';

const styles = {
    root: {
        boxSizing: 'border-box',
        height: '100%',
        overflowY: 'auto',
    },
};

interface MysteryTestHotelPageProps {
    testEnvironment: boolean;
}

const MysterytestHotelPage = (props: MysteryTestHotelPageProps) => {
    const isAdmin = useSelector(Selector.User.isAdmin);
    const hasTesterCompanyAccess = useSelector(Selector.User.hasTesterCompanyAccess);
    const mysteryTestLoaded = useSelector(Selector.MysteryTest.loaded);
    const mysteryTestId = useSelector(Selector.MysteryTest.mysteryTestId);
    const activeVersion = useSelector(Selector.QuestionList.activeVersion);
    const viewingVersion = useSelector(Selector.QuestionList.viewingVersion);
    const isViewingOldVersion = viewingVersion !== activeVersion;

    if (!isAdmin && !hasTesterCompanyAccess) {
        return null;
    }

    return (
        <Box sx={styles.root}>
            <MysteryTestHeader
                title={
                    props.testEnvironment ?
                        'Mystery-Check Test Configuration: "Hotel garni / Pension"' :
                        'Mystery-Check: "Hotel garni / Pension"'
                }
            />

            {!mysteryTestLoaded && !props.testEnvironment && <CircularProgress size={24} sx={{ mt: 2 }} />}
            {((mysteryTestLoaded && mysteryTestId) || props.testEnvironment) &&
                <MysteryTestHotel testEnvironment={props.testEnvironment} />
            }
            {(mysteryTestLoaded && !mysteryTestId && !isViewingOldVersion) && <StartMysteryTestInfo />}
            {(mysteryTestLoaded && !mysteryTestId && isViewingOldVersion) && (
                <Alert severity={'info'}>
                    Kein Mystery-Test für Version {viewingVersion} vorhanden.
                </Alert>
            )}
        </Box>
    );
};

export default MysterytestHotelPage;
